module.exports = __webpack_public_path__ + "static/media/icon-certificate.cef1676f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Schools/assets/img/icon-certificate.svg
// module id = 642
// module chunks = 0